<section class="register-page">
  <div class="register-hero">
    <span class="badge">New Stakeholder Registration</span>
    <h1>Select Your Stakeholder Category</h1>
    <p>
      Choose the category that best describes your organization to proceed with the registration form.
      All information submitted is subject to verification by MSLDC.
    </p>
  </div>

  <div class="register-grid">
    @for (category of categories; track category.title) {
      <article class="category-card" [class]="'accent-' + category.accent">
        <div class="card-icon">{{ category.icon }}</div>
        <h2>{{ category.title }}</h2>
        <p>{{ category.description }}</p>
        <a [routerLink]="category.route" class="card-button">{{ category.buttonLabel }} →</a>
      </article>
    }
  </div>

  <div class="register-note">
    <strong>Note:</strong>
    Registration is subject to approval by Maharashtra State Load Despatch Centre (MSLDC). Upon successful
    submission, you will receive an acknowledgement on your registered email.
  </div>
</section>
